import { DisputeStatus } from 'api/escrow/types';

const DISPUTE_STATUS_CONFIG: Record<DisputeStatus, { label: string; className: string }> = {
  open_triage: { label: 'Open (Triage)', className: 'bg-[#FFA800]/10 text-[#FF6B00]' },
  triage_resolved: { label: 'Resolved (Triage)', className: 'bg-[#ECFBEF] text-[#7DDCA3]' },
  pending_arbitration_prefunding: { label: 'Awaiting Fees', className: 'bg-[#EAEAF9] text-[#8C8CAA]' },
  arbitration_in_progress: { label: 'In Arbitration', className: 'bg-[#DCEDF5] text-[#0000FF]' },
  deemed_loss_resolved: { label: 'Deemed Loss', className: 'bg-[#E94169]/10 text-[#E94169]' },
  arbitration_decision_issued: { label: 'Decision Issued', className: 'bg-[#D6F0C6] text-[#4BAA00]' },
  closed: { label: 'Closed', className: 'bg-[#6B6B6B]/10 text-[#6B6B6B]' },
};

type Props = { status: DisputeStatus };

export default function DisputeStatusBadge({ status }: Props) {
  const config = DISPUTE_STATUS_CONFIG[status] ?? { label: status, className: 'bg-gray-100 text-gray-600' };
  return <span className={`px-3 py-1.5 rounded-[20px] text-xs font-semibold ${config.className}`}>{config.label}</span>;
}
